module.exports = __webpack_public_path__ + "pc/img/modal_10.07bbbf20.png";